import React from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postThanetCouncilForms } from "../../redux/actions/thanetCouncilActions";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";

const ShiftInductionForm = ({ appData, postThanetCouncilFormsFunc }) => {
  const initialData = {
    signature: `${appData.firstName} ${appData.lastName}`,
    name: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <p className={"mb-2"}>
            <b>
              Please sign below to confirm that you have received, and
              understood, the following information:
            </b>
          </p>
          <p className={"h5"}>
            <b>Shifts</b>
          </p>
          <p>
            TDC notifies HRGO of the number of loaders and drivers they require,
            the day before. (For a Monday we receive notification on a Friday).
          </p>
          <ul className={"mb-2"}>
            <li className={"mb-1"}>
              If you are required, you will receive a text message to state you
              are booked for the next shift.
            </li>
            <li className={"mb-1"}>
              If you do not receive a text message, you will be ‘on call’.
              Please ensure your phone is on as (if required) you will receive a
              call from any time after 05:00hrs.
            </li>
          </ul>
          <p className={"h5"}>
            <b>Out of Hours Number</b>
          </p>
          <p>
            <mark>
              <b>Please call – do not text</b>
            </mark>{" "}
            the out of hours number if you are not able to make your shift, due
            to illness, or if you are going to be late. Sickness must be
            reported prior to 04:30hrs.
          </p>
          <ul className={"mb-2"}>
            <li className={"mb-1"}>
              Please only use the out of hours number for emergency issues only.
            </li>
            <li className={"mb-1"}>
              If your query is not an emergency, please call the office on
              01843591798.
            </li>
            <li className={"mb-1"}>
              Office hours are Monday to Friday, 08:30 – 17:30hrs.
            </li>
          </ul>
        </div>
      ),
    },
    signature: {
      type: "text",
      title: "Signed",
      value: getVal("signature"),
      disabled: true,
    },
    name: {
      type: "text",
      title: "Print Name",
      value: getVal("name"),
      disabled: true,
    },
    date: {
      type: "text",
      title: "Date",
      value: getVal("date"),
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const submitted =
    appData.thanetCouncilOnboarding &&
    appData.thanetCouncilOnboarding.shiftInduction;

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postThanetCouncilFormsFunc("shiftInduction", {
      ...fieldValuesPayload,
      date: moment().toISOString(),
    });
    history.push("/profile/edit/thanet-council-onboarding");
  };

  const redirectBack = () => {
    history.push("/profile/edit/thanet-council-onboarding");
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Shift Induction"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"thanetCouncil"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

ShiftInductionForm.propTypes = {
  appData: any,
  postThanetCouncilFormsFunc: func,
};

const mapDispatchToProps = {
  postThanetCouncilFormsFunc: postThanetCouncilForms,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(ShiftInductionForm);
